import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueMq from 'vue-mq';
import BootstrapVue from 'bootstrap-vue';
import VCalendar from 'v-calendar';
import VueSweetalert2 from 'vue-sweetalert2';
import VueI18n from 'vue-i18n';
import SortedTablePlugin from 'vue-sorted-table';
import axios from 'axios';

import App from './App.vue';
import router from './router';
import store from './store';
import interceptorsSetup from './plugins/axios';
import Translation from './trans';
import GlobalMixin from './mixins/globalMixins';
import VMoney from './plugins/currency-input';
import { currency, date, formatDate, uniDate, amount, symbol } from './filters';
import { dateLocale } from './constants';

import 'sweetalert2/dist/sweetalert2.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'animate.css/animate.css';
import '@/assets/sass/app.scss';
import '@/assets/user/css/fontawesome/all.min.css';
import '@/assets/user/css/theme.css';
import '@/assets/user/css/common.css';
import '@/assets/user/css/extend.css';

Vue.use(VMoney, { precision: 0, allowBlank: true });
Vue.use(Vuelidate);
Vue.use(VueSweetalert2, {
  target: '.root-container',
  confirmButtonColor: '#41b882',
  confirmButtonText: '',
  showCancelButton: false,
  showConfirmButton: true,
});
Vue.use(VCalendar, dateLocale);
Vue.use(VueMq, {
  breakpoints: { mobile: 450, tablet: 900, laptop: 1050, desktop: Infinity },
});
Vue.use(BootstrapVue);
Vue.use(SortedTablePlugin, {
  ascIcon:  '<i class="fas fa-arrow-up ml-2 float-right"></i>',
  descIcon: '<i class="fas fa-arrow-down ml-2 float-right"></i>',
});
Vue.use(VueI18n);

Vue.mixin(GlobalMixin);
Vue.mixin(Translation);

Vue.filter('formatDate', formatDate);
Vue.filter('symbol', symbol);
Vue.filter('amount', amount);
Vue.filter('currency', currency);
Vue.filter('date', date);
Vue.filter('uni-date', uniDate);

const i18n = new VueI18n({
  locale: window.localStorage.getItem('_lang') || 'mn',
  messages: {
    mn: require('./translations/mn.json'),
    en: require('./translations/en.json'),
    ja: require('./translations/jp.json'),
  },
});

Vue.component('IcDialog',      () => import('./components/global/IcDialog/index.vue'));
Vue.component('IcButton',      () => import('./components/global/IcButton/index.vue'));
Vue.component('IcInput',       () => import('./components/global/IcInput/index.vue'));
Vue.component('IcTab',         () => import('./components/global/IcTab/index.vue'));
Vue.component('CurrencyInput', () => import('./components/CurrencyInput.vue'));
Vue.component('Loader',        () => import('./components/global/Loader/index.vue'));
Vue.component('LoaderBlock',   () => import('./components/global/LoaderBlock/index.vue'));
Vue.component('AppInput',      () => import('./components/global/AppInput/index.vue'));
Vue.prototype.$axios = axios;

store.dispatch('common/initTheme');

const app = new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

interceptorsSetup(app);
